import styled from 'styled-components';

export const DatePanelSC = styled.div`
  --day-size: 40px;
  --day-height: 32px;
  --selected-day: ${({ theme }) => theme.color.solid.selection};
  --secondary-day-color: ${({ theme }) => theme.color.tint.tertiary};
  --selected-range: ${({ theme }) => theme.color.state.selected};
  --today-color: ${({ theme }) => theme.color.solid.accent};
  --day-color: ${({ theme }) => theme.color.tint.action};
  --border-radius: 16px;

  width: fit-content;
  height: fit-content;

  .days {
    margin: 8px 0;
  }

  .day {
    width: 100%;
    min-width: var(--day-size);
    height: var(--day-height);

    ${({ theme }) => theme.mappedTypography.buttonText.default};
  }

  .weekdays {
    height: 48px;
    border-bottom: 1px solid ${({ theme }) => theme.color.border.emphasis};
  }

  .weekdays,
  .days {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    row-gap: 8px;
  }

  .weekday {
    width: 100%;
    min-width: var(--day-size);
    height: 100%;

    display: flex;
    justify-content: center;
    align-items: center;

    text-align: center;
    color: ${({ theme }) => theme.color.tint.secondary};
    ${({ theme }) => theme.mappedTypography.buttonText.default};
  }

  button.day {
    width: 100%;

    border: 0;
    border-radius: var(--border-radius);
    cursor: pointer;
    background-color: transparent;
    color: var(--day-color);

    transition: background-color 0.2s;

    &:hover:not(.selected):not(.in-range):not(:disabled) {
      background: ${({ theme }) => theme.color.state.hover};
    }

    &:hover.selected:not(:disabled) {
      background: ${({ theme }) => theme.createOverlayColor(theme.color.solid.selection, 'hover')};
    }

    &:hover.in-range:not(:disabled) {
      background: ${({ theme }) => theme.createOverlayColor(theme.color.state.selected, 'hover')};
    }
  }

  button.day.today {
    color: var(--today-color);
  }

  button.day.secondary {
    color: var(--secondary-day-color);
  }

  button.day.in-range:not(.secondary) {
    border-top: 1px solid ${({ theme }) => theme.color.solid.selection};
    border-bottom: 1px solid ${({ theme }) => theme.color.solid.selection};
  }

  button.day.in-range,
  button.day.will-be-in-range {
    &:nth-child(7n),
    &:nth-child(1n) {
      border-radius: 0 !important;
    }
  }

  button.day.will-be-in-range:not(.secondary),
  button.day.will-be-range-end:not(.secondary),
  button.day.will-be-range-start:not(.secondary),
  button.day.in-range:not(.secondary) {
    background-color: var(--selected-range);
  }

  button.day.will-be-in-range:not(.secondary),
  button.day.in-range:not(.secondary) {
    border-radius: 0;
  }

  button.day.selected:not(.secondary) {
    color: ${({ theme }) => theme.color.tint.action};
    background-color: var(--selected-day);
  }

  button.day.will-be-in-range:nth-child(7n),
  button.day.in-range:nth-child(7n),
  button.day.range-end,
  button.day.will-be-range-end {
    border-radius: 0 var(--border-radius) var(--border-radius) 0;
  }

  button.day.will-be-in-range:nth-child(7n + 1),
  button.day.in-range:nth-child(7n + 1),
  button.day.range-start,
  button.day.will-be-range-start {
    border-radius: var(--border-radius) 0 0 var(--border-radius);
  }

  button.day.range-start {
    border-radius: var(--border-radius) 0 0 var(--border-radius) !important;
  }

  button.day.range-start:nth-child(7n),
  button.day.range-end:nth-child(7n + 1),
  button.day.will-be-range-start:nth-child(7n),
  button.day.will-be-range-end:nth-child(7n + 1) {
    border-radius: var(--border-radius);
  }

  .day.secondary.visible {
    visibility: visible;
  }

  button.day:disabled,
  .calendar-header__button:disabled {
    opacity: 0.45;
  }
`;

export const DateRangePanelSC = styled.div`
  display: flex;
  align-items: center;
`;
